import { GiTrousers } from 'react-icons/gi';
import { RiTShirt2Fill } from 'react-icons/ri';
import { MdOutlineAccessibility } from 'react-icons/md';
import { Chip } from '@ds';
import { UserModalHeader } from '@features/components/UserModalLayout';
import { ConditionalRender } from '@ui';
import { Employee, EmployeeComposed, EmployeeRole } from '@/api/apis/resources';

type UserHeaderProps = {
  user: Employee | EmployeeComposed;
};

export const UserHeader = ({ user }: UserHeaderProps) => {
  const { firstName, lastName, profilePhoto } = user;
  const isSpecialistSurgeonLeadRole =
    user.roles.includes(EmployeeRole.ClinicalSpecialist) ||
    user.roles.includes(EmployeeRole.RetrievalSurgeon) ||
    user.roles.includes(EmployeeRole.ClinicalLead);

  return (
    <UserModalHeader firstName={firstName} lastName={lastName} photo={profilePhoto || ''} userRole="">
      <ConditionalRender show={isSpecialistSurgeonLeadRole}>
        <div className="flex gap-1.5">
          <Chip
            classNames={{
              base: 'bg-base-60',
              content: 'flex gap-1 items-center',
            }}
          >
            <GiTrousers size={14} />
            <span>{user.scrubSizeBottom}</span>
          </Chip>
          <Chip
            classNames={{
              base: 'bg-base-60',
              content: 'flex gap-1 items-center',
            }}
          >
            <RiTShirt2Fill size={14} />
            <span>{user.scrubSizeTop}</span>
          </Chip>
          <Chip
            classNames={{
              base: 'bg-base-60',
              content: 'flex gap-1 items-center',
            }}
          >
            <MdOutlineAccessibility size={14} />
            <span>{user.weight} lb</span>
          </Chip>
        </div>
      </ConditionalRender>
    </UserModalHeader>
  );
};
